module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/dj-278a5a5fce9a6090ce80ad1fc1eaf1fc.svg";